<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <template v-slot:activator="{ on, attrs }">
      <v-list-item v-on="on" v-bind="attrs">
        <v-list-item-title>Movimentações</v-list-item-title>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title class="green lighten-4 primary--text font-weight-bold">
        Histórico
      </v-card-title>
      <v-card-text>
        <v-list class="mt-3" three-line>
          <template v-for="(mov, i) in movimentacao">
            <v-list-item :key="i">
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold wrap-text"
                  >{{ mov.sequencia }}º
                  <i v-if="mov.observacao != ''"
                    >"{{ mov.observacao }}"</i
                  ></v-list-item-title
                >
                <v-list-item-subtitle>
                  {{ mov.descstatus }} ({{ mov.colabempresa }} em
                  {{ mov.data }} às {{ mov.hora }})
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider
              :key="movimentacao.length + i"
              v-if="i != movimentacao.length - 1"
            ></v-divider>
          </template>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secondary" small rounded @click="dialog = false"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    movimentacao: Array,
  },
  data: () => ({
    dialog: false,
  }),
};
</script>

<style scoped>
.wrap-text {
  -webkit-line-clamp: unset !important;
  white-space: unset !important;
}
</style>